import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AnalyticsService, AppRoutes, DashboardAnalyticsEvent, HostedGamesRoutes } from '@core';
import { Router } from '@angular/router';
import { OrIconComponent } from '@ui-components';

@Component({
  selector: 'lib-dashboard-empty-state',
  templateUrl: './dashboard-empty-state.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OrIconComponent],
  standalone: true
})
export class DashboardEmptyStateComponent {
  private readonly router: Router = inject(Router);
  private readonly analyticsService: AnalyticsService = inject(AnalyticsService);

  goToSearchGames(): void {
    this.analyticsService.buttonClick(DashboardAnalyticsEvent.EmptyStateFindGames);
    this.router.navigateByUrl(`/${AppRoutes.FIND_GAMES}`);
  }

  goToGameCreator(): void {
    this.analyticsService.buttonClick(DashboardAnalyticsEvent.EmptyStateCreateGame);
    this.router.navigateByUrl(`${AppRoutes.HOST}/${HostedGamesRoutes.CREATE_GAME}`);
  }
}
